import { Delete } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Box, Chip, IconButton, Modal, Stack, Typography } from "@mui/material";
import moment from "moment/moment";
import React, { memo, useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Postrequestcall } from "../../../request/Postrequest";
import TimesheetSkeletonLoader from "../shared/components/TimesheetSkeletonLoader";

import PictureViewer from "../../../common/PictureViewer";
import {
  DELETE_CLIENT_TIMESHEETS,
  FETCH_INDIVIDUAL_CLIENT_TIMESHEETS_NEW
} from "../../../constant/Apipath";
import DeletConfirmModal from "../shared/modals/DeleteConfirmModal";
import { ClientEnglishFallback } from "../../constant/ClientEnglishFallback";
import { ClientUDFieldComponent } from "../../safety-observation/ClientUDFieldComponent";

export const formatTime = (time) => {
  try {
    if (time === undefined || time === null) {
      return "0.00";
    }
    const [hours, min] = time.toString().split(":");
    let formattedTime = "";
    if (hours[0] == "0") {
      return `${hours[1]}:${min}`;
    }
    if (Number(hours) > 9) {
      formattedTime = `${hours}:${min}`;
    } else {
      formattedTime = `${min}`;
    }

    return formattedTime;
  } catch (error) {
    console.error("Error formatting time:", error);
    return time;
  }
};

const fetchCrewTimesheet = async (id, userId, token, value = "clientTimesheetId") => {
  try {
    const payload = {
      PageNr: 1,
      NrOfRecPerPage: 100,
      FullSearch: "",
      UserId: Number(userId),
      IncludeRecordNr: true,
      FetchAllowedRecordsOnly: false,
      DoNotShowInSystemFields: false,
      SearchList: [{ [value]: id }],
      SortList: [{}]
    };

    const response = await Postrequestcall(FETCH_INDIVIDUAL_CLIENT_TIMESHEETS_NEW, payload, token);
    
    // Map the new response structure to the old one for compatibility
    if (response?.data?.data) {
      response.data.data = response.data.data.map(job => ({
        ...job,
        timesheetHoursList: job.timesheetHours ? [job.timesheetHours] : [],
        timesheetEmployeesList: job.timesheetEmployees ? [job.timesheetEmployees] : [],
        timesheetActivitiesList: job.timesheetActivities ? [job.timesheetActivities] : []
      }));
    }
    
    return response;
  } catch (error) {
    console.error("Error fetching crew timesheet:", error);
    return { data: { data: [] } };
  }
};

const ListingItem = memo(({ item, handelExpand, index, TEXT_MILEAGE, TEXT_HOURS, parentType }) => {
  const [showPictureView, setShowPictureView] = useState(false);
  const [pictureIndex, setPictureIndex] = useState(0);

  const pictureListArray =
    item?.pictureList?.map((item) => {
      return {
        src: item?.fileUrl,
        thumbFileUrl: item?.thumbFileUrl
      };
    }) || [];
  const handlePictureClick = (index) => {
    setPictureIndex(index);
    setShowPictureView(true);
  };

  const handlePictureClose = () => setShowPictureView(false);
  if (!item) return null;
  const accordionExpandDisable = () => {
    try {
      if (Number(item?.timesheetEmployeesList?.[0]?.mileage) > 0) {
        return true;
      }

      if (item?.pictureList?.length > 0) {
        return true;
      }

      if (item?.notes && item?.notes?.trim() !== "") {
        return true;
      }

      if (item?.udFieldsList?.length > 0) {
        return true;
      }

      if (
        item?.timesheetActivitiesList?.length > 0 &&
        item?.timesheetActivitiesList[0]?.udFieldsList?.length > 0
      ) {
        return true;
      }

      return false;
    } catch (error) {
      console.error("Error in accordionExpandDisable:", error);
      return false;
    }
  };

  return (
    <>
      <PictureViewer
        isOpen={showPictureView}
        viewerIndex={pictureIndex}
        pictures={pictureListArray}
        onClose={() => handlePictureClose()}
      />

      <Stack
        sx={{
          border: "1px solid #e0e0e0",
          backgroundColor: "white",
          borderRadius: "10px"
        }}>
        <Stack
          sx={{
            padding: "10px"
          }}>
          <Stack sx={{ gap: 1 }} >
            {item?.timesheetHoursList?.map((data, i) => (
              <>
                <Stack>
                  <Stack sx={{ alignItems: "center", justifyContent: "space-between" }} direction="row">
                    <Stack>
                      <Typography variant="h6">
                        {item?.clientJobCode} - {item?.clientJobName}
                      </Typography>
                      {item?.timesheetActivitiesList?.[0]?.clientJobActivityCode && (
                        <Typography sx={{ color: "grey" }}>
                          {item.timesheetActivitiesList[0].clientJobActivityCode} - {item.timesheetActivitiesList[0].clientJobActivityName}
                        </Typography>
                      )}
                    </Stack>

                    {accordionExpandDisable() && (
                      <IconButton onClick={() => handelExpand(index)}>
                        {item?.expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                      </IconButton>
                    )}
                  </Stack>
                </Stack>
                <Stack sx={{ alignItems: "flex-end" }}>
                  <Stack direction="row" sx={{ alignItems: "center", gap: 1 }}>
                    <Typography sx={{ color: "grey" }}>{TEXT_HOURS}</Typography>
                    <Typography>
                      {formatTime(item?.timesheetHoursList[0]?.hours) || "0.00"}
                    </Typography>
                  </Stack>
                  <Stack direction="row" sx={{ alignItems: "center", gap: 1 }}>
                    {parentType?.includes("Clock In") && item?.timesheetHoursList[0]?.clockInTime && (
                      <Typography sx={{ color: "grey", fontSize: "0.8rem" }}>
                        In: {item?.timesheetHoursList[0]?.clockInTime}
                      </Typography>
                    )}
                    {parentType?.includes("Clock In") && item?.timesheetHoursList[0]?.clockOutTime && (
                      <Typography sx={{ color: "grey", fontSize: "0.8rem" }}>
                        Out: {item?.timesheetHoursList[0]?.clockOutTime}
                      </Typography>
                    )}
                  </Stack>
                </Stack>
              </>
            ))}
          </Stack>
        </Stack>
        {item.expanded && (
          <Stack
            sx={{
              gap: 1,
              padding: "10px",
              backgroundColor: "#fafafa",
              borderRadius: "0px 0px 10px 10px "
            }}>
            {item?.timesheetEmployeesList?.[0]?.mileage > 0 && (
              <Stack>
                <Typography sx={{ color: "grey" }}>{TEXT_MILEAGE}</Typography>
                <Typography>
                  {item?.timesheetEmployeesList[0].mileage}{" "}
                  {item?.timesheetEmployeesList[0].mileageUnit}
                </Typography>
              </Stack>
            )}
            {item?.notes && <Typography sx={{ wordBreak: "break-all" }}>{item.notes}</Typography>}
            {item?.pictureList?.length > 0 && (
              <Stack
                direction="row"
                 sx={{ gap: 1, width: "100%", overflowX: "auto", scrollbarWidth: "none" }}>
                {item.pictureList.map((url, index) => (
                  // eslint-disable-next-line jsx-a11y/img-redundant-alt
                  <img
                    onClick={() => handlePictureClick(index)}
                    key={index}
                    src={url?.thumbFileUrl}
                    alt={`Image ${index + 1}`}
                    style={{
                      maxWidth: "100px",
                      maxHeight: "100px",
                      minWidth: "100px",
                      minHeight: "100px",
                      objectFit: "cover",
                      cursor: "pointer",
                      borderRadius: "10px"
                    }}
                  />
                ))}
              </Stack>
            )}
            {item?.udFieldsList?.length > 0 && (
              <Stack direction="row" sx={{ gap: 1, flexWrap: "wrap" }}>
                <ClientUDFieldComponent mode="view" udFields={item.udFieldsList} />
              </Stack>
            )}
            {item?.timesheetActivitiesList?.length > 0 && item?.timesheetActivitiesList[0]?.udFieldsList?.length > 0 && (
              <Stack direction="row" sx={{ gap: 1, flexWrap: "wrap" }}>
                <ClientUDFieldComponent mode="view" udFields={item.timesheetActivitiesList[0].udFieldsList} />
              </Stack>
            )}
          </Stack>
        )}
      </Stack>
    </>
  );
});

ListingItem.displayName = "ListingItem";

function ClientTimesheetViewIndividual({ isOpen, onClose, item, reloadData }) {
  const { loginData, multiLanguageData } = useSelector((state) => state?.main);
  const userId = loginData?.userInformation?.UserId;
  const token = loginData?.accessToken;
  const [loader, setLoader] = useState(true);
  const [deleteModal, setDeleteModal] = useState(false);
  const [timeSheetData, setTimesheetData] = useState([]);
  const [deleteLoading, setDeleteLoading] = useState(false);

  const { TEXT_ACTION_BE_UNDONE, TEXT_SURE_WANT_TO_DELETE_THIS_TIMESHEET } =
    ClientEnglishFallback?.DeletConfirmModal(multiLanguageData?.DeletConfirmModal || {});

  const {
    TEXT_NO_TIMESHEET_DATA,
    TEXT_SUBMITTED_ON,
    TEXT_IN_REVIEW,
    TEXT_APPROVED,
    TEXT_REJECTED,
    TEXT_UNKNOWN,
    TEXT_MILEAGE,
    TEXT_HOURS
  } = ClientEnglishFallback?.ClientTimesheetViewIndividual(
    multiLanguageData?.ClientTimesheetViewIndividual || {}
  );

  const getData = useCallback(async () => {
    if (!item?.id || !userId || !token) return;
    try {
      const response = await fetchCrewTimesheet(item.id, userId, token);
      if (response.status === 200) {
        const list = (response?.data?.data || []).map((j) => ({
          ...j,
          expanded: true
        }));
        setTimesheetData(list);
      }
    } catch (error) {
      console.error("getData-> Error fetching crew timesheet:", error);
      setTimesheetData([]);
    } finally {
      setLoader(false);
    }
  }, [item?.id, userId, token]);

  const handelExpand = (index) => {
    const newData = [...timeSheetData];
    newData.map((item, i) => (i == index ? (item.expanded = !item.expanded) : item));
    setTimesheetData(newData);
  };

  const deleteTimesheet = async (id) => {
    try {
      setDeleteLoading(true);
      const payload = {
        userId: loginData?.userInformation?.UserId,
        returnRecordError: true,
        softDelete: false,
        deleteList: [{ id: Number(id) }]
      };

      await Postrequestcall(DELETE_CLIENT_TIMESHEETS, payload, loginData?.accessToken);
    } catch (error) {
      console.error("deleteTimesheet-> Error deleting timesheet:", error);
      alert("Something went wrong. Please try again later.");
    } finally {
      setDeleteLoading(false);
      setDeleteModal(false);
      onClose();
      reloadData();
    }
  };

  const renderChip = (status) => {
    const statusMap = {
      "In Review": { label: "In Review", translateLabel: TEXT_IN_REVIEW },
      Approved: {
        label: "Approved",
        translateLabel: TEXT_APPROVED,
        bgColor: "#c6d9ba",
        color: "#114503"
      },
      Rejected: {
        label: "Rejected",
        translateLabel: TEXT_REJECTED,
        bgColor: "#fcbdbd",
        color: "#6e0c0c"
      }
    };
    const statusData = statusMap[status] || {
      label: "Unknown",
      translateLabel: TEXT_UNKNOWN,
      color: "#9E9E9E"
    };

    return (
      <Chip
        label={statusData.translateLabel}
        sx={{
          backgroundColor: statusData.bgColor,
          color: statusData.color
        }}
      />
    );
  };

  useEffect(() => {
    if (isOpen) {
      getData();
    }
  }, [isOpen, getData]);

  if (!isOpen) return null;

  return (
    <>
      <DeletConfirmModal
        onClose={() => setDeleteModal(false)}
        title={TEXT_ACTION_BE_UNDONE}
        isOpen={deleteModal}
        loading={deleteLoading}
        onConfirm={() => {
          deleteTimesheet(item?.id);
        }}
        heading={TEXT_SURE_WANT_TO_DELETE_THIS_TIMESHEET}
      />
      <Modal
        open={isOpen}
        onClose={onClose}
        aria-labelledby="timesheet-details-modal"
        aria-describedby="timesheet-details-description">
        <Box className="client-modal-responsive">
          <Stack sx={{ display: "flex",  justifyContent: "space-between", alignItems: "center" }}  direction="row">
            {!loader && timeSheetData.length > 0 ? (
              <Stack>{renderChip(item?.status)}</Stack>
            ) : (
              <div />
            )}
            <Stack sx={{ gap: 1 }} direction="row" >
              {item?.status === "In Progress" && (
                <IconButton
                  size="small"
                  onClick={() => {
                    setDeleteModal(true);
                  }}
                  aria-label="close">
                  <Delete />
                </IconButton>
              )}
              <IconButton size="small" onClick={onClose} aria-label="close">
                <CloseIcon />
              </IconButton>
            </Stack>
          </Stack>

          {loader ? (
            <TimesheetSkeletonLoader variant="detail" />
          ) : (
            <>
              {timeSheetData.length > 0 ? (
                <Stack  sx={{ gap: 1, marginTop: "10px" }}>
                  <Stack direction="row" sx={{ justifyContent: "space-between" }}>
                    <Stack>
                      <Typography sx={{ color: "gray" }}>
                        {moment(timeSheetData[0]?.date).format("MMMM DD, YYYY")}
                      </Typography>
                    </Stack>
                    <Stack sx={{ gap: 0.5 }} direction="row" >
                      <Typography sx={{ color: "grey" }}>{TEXT_SUBMITTED_ON}</Typography>
                      <Typography sx={{ color: "gray" }}>
                        {moment(timeSheetData[0]?.dateSubmitted).format("MMMM DD, YYYY")}
                      </Typography>
                    </Stack>
                  </Stack>

                  <Stack
                    spacing={1}
                    sx={{
                      scrollbarWidth: "none",
                      maxHeight: "500px",
                      overflow: "scroll",
                      padding: "5px"
                    }}>
                    {timeSheetData.map((itemJob, index) => (
                      <div key={itemJob.id || index}>
                        <ListingItem
                          index={index}
                          handelExpand={handelExpand}
                          item={itemJob}
                          parentType={item?.type}
                          TEXT_MILEAGE={TEXT_MILEAGE}
                          TEXT_HOURS={TEXT_HOURS}
                        />
                      </div>
                    ))}
                  </Stack>
                </Stack>
              ) : (
                <Typography sx={{ textAlign: "center", my: 3 }}>
                  {TEXT_NO_TIMESHEET_DATA}
                </Typography>
              )}
            </>
          )}
        </Box>
      </Modal>
    </>
  );
}

export default ClientTimesheetViewIndividual;
export { fetchCrewTimesheet };

